import { render, staticRenderFns } from "./SaleCounter.vue?vue&type=template&id=6ce5eb5f"
import script from "./SaleCounter.vue?vue&type=script&lang=js"
export * from "./SaleCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports